<button
  *ngIf="goBackRoute"
  type="button"
  class="go-back-action"
  [attr.data-e2e-id]="e2eId"
  i2gTrackable
  [trackingObject]="goBackRoute.trackingObject"
  [trackingAction]="goBackRoute.trackingAction"
  (click)="onGoBack()"
>
  <div class="go-back-contents">
    <i2g-icon
      name="back-navigation"
      size="medium"
      [ngClass]="colorMode"
    ></i2g-icon>

    <span class="sr-text">
      {{ 'ACTION.GO_BACK' | translate }}
    </span>
  </div>
</button>
